import { render, staticRenderFns } from "./glossary.vue?vue&type=template&id=0a43f9b4&scoped=true&"
import script from "./glossary.vue?vue&type=script&lang=js&"
export * from "./glossary.vue?vue&type=script&lang=js&"
import style0 from "./glossary.vue?vue&type=style&index=0&id=0a43f9b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a43f9b4",
  null
  
)

export default component.exports